export const blockIconsImagePalette = (
	<span className='material-symbols-outlined'>palette</span>
);
